export default "__VITE_ASSET__BLS2oCde__"